var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('partnerSchedule',{attrs:{"partners":_vm.partners,"programPartnerSchedules":_vm.programPartnerSchedules,"programs":_vm.programs},on:{"getPrgPartnerSchedule":_vm.getPrgPartnerSchedule}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }